export default "__VITE_ASSET__B33w5s_K__"